import {
  createStudyQueryStudiesStudyIdQueriesPost,
  CreateStudyQueryStudiesStudyIdQueriesPostData,
  CreateStudyQueryStudiesStudyIdQueriesPostResponse,
  HTTPValidationError,
} from '@common/config/api/client'
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import studyQueryKeys from './queryKeyFactory'

export function useCreateStudyQuery(): UseMutationResult<
  CreateStudyQueryStudiesStudyIdQueriesPostResponse,
  AxiosError<HTTPValidationError>,
  CreateStudyQueryStudiesStudyIdQueriesPostData
> {
  const queryClient = useQueryClient()

  return useMutation<
    CreateStudyQueryStudiesStudyIdQueriesPostResponse,
    AxiosError<HTTPValidationError>,
    CreateStudyQueryStudiesStudyIdQueriesPostData
  >({
    mutationFn: async (query) => {
      const response = await createStudyQueryStudiesStudyIdQueriesPost({
        path: query.path,
        body: query.body,
        throwOnError: true,
      })
      return response.data
    },
    onSuccess: (_data, query) => {
      queryClient.invalidateQueries({ queryKey: studyQueryKeys.list({ study_id: query.path.study_id }) })
    },
  })
}
